import { gql } from '@apollo/client/core';

export const PUSH_NOTIFICATION_CAPABILITY = gql`
  query PushNotificationCapability {
    webPushContext {
      capability {
        enabled
        public_key
      }
    }
  }
`;

export const PUSH_NOTIFICATION_PREFERENCES = gql`
  query PushNotificationPreferences {
    webPushContext {
      preferences {
        kind
        enabled
        available
      }
    }
  }
`;

export const UPSERT_CURRENT_PUSH_SUBSCRIPTION = gql`
  mutation UpsertCurrentPushSubscription($input: UpsertWebPushSubscriptionInput!) {
    upsertWebPushSubscription(input: $input) {
      id
    }
  }
`;

export const DELETE_CURRENT_PUSH_SUBSCRIPTION = gql`
  mutation DeleteCurrentPushSubscription($input: WebPushEndpointInput!) {
    deleteWebPushSubscription(input: $input) {
      id
    }
  }
`;

export const TEST_CURRENT_PUSH_SUBSCRIPTION = gql`
  mutation TestCurrentPushSubscription($input: WebPushEndpointInput!) {
    testWebPushSubscription(input: $input) {
      id
    }
  }
`;

export const UPDATE_PUSH_NOTIFICATION_PREFERENCE = gql`
  mutation UpdatePushNotificationPreference($input: UpdateWebPushNotificationPreferenceInput!) {
    updateWebPushNotificationPreference(input: $input) {
      web_push_notification_preferences {
        kind
        enabled
        available
      }
    }
  }
`;
